import image1 from "../assets/images/initiatives/initiativeCard1.webp";
import image2 from "../assets/images/initiatives/initiativeCard2.webp";
import image3 from "../assets/images/initiatives/initiativeCard3.webp";

export const initiativeCardData = [
  {
    id: 1,
    title: "Finding Answers",
    description:
      "We're building an AI engine that can analyze data across research domains to estimate what's most likely true automatically and transparently.",
    image: image1,
    link: "/initiatives/estimating-truth",
    author: "Spiritual Data",
    buttonText: "Learn about Truth Estimation",
  },
  {
    id: 2,
    title: "Fixing the Record",
    description:
      "We're working to ensure parapsychology and consciousness studies are accurately represented in public knowledge platforms like Wikipedia.",
    image: image2,
    link: "/initiatives/wikipedia-advocacy",
    author: "Spiritual Data",
    buttonText: "Explore Our Wikipedia Advocacy",
  },
  {
    id: 3,
    title: "Proving What's Possible",
    description:
      "Through real-world experiments, we're scientifically testing and certifying psychic abilities witnessed, recorded, and peer-reviewed.",
    image: image3,
    link: "/initiatives/psychic-ability-certification",
    author: "Spiritual Data",
    buttonText: "See the Research in Action",
  },
];
